import request from '../../library/request';
import store from '../../store';
import setGlobalState from '../setGlobalState';

export const getCrowds = async () => {
    const res = await request('crowds.getCrowds', 'get', `/package/${store.getState().account.pid}/crowd`);
    setGlobalState('crowds.crowds', res);
};

export const searchCrowds = async (search, limit=10, crowdsOffset=0, lastCrowdOffset=0) => {
    if(!crowdsOffset && !lastCrowdOffset){
        setGlobalState('crowds.searchResults', []);
    }
    const res = await request('crowds.searchCrowds', 'get', `/package/${store.getState().account.pid}/crowd/search`, {search, limit, lastCrowdOffset, crowdsOffset});
    if(!res || !res.length){
        return;
    }
    if(crowdsOffset || lastCrowdOffset){
        const crowds = [...store.getState().crowds.searchResults];
        let currentCrowd = crowds[crowdsOffset];
        if(currentCrowd)
            crowds[crowdsOffset] = {...currentCrowd, members: [...currentCrowd.members, ...res[0].members]};
        setGlobalState('crowds.searchResults', [...crowds, ...res.slice(1)]);
    } else {
        setGlobalState('crowds.searchResults',res);

    }
    const newMembersCount = res.reduce((acc, table) => acc+=table.members.length,0);
    return !newMembersCount; //check if there are new members in the search results
};